<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
<div class="card" *ngIf="moduleAccess=='Full'">
	<h2 class="card-title mb-0 pb-0">
		Scales
		<a class="btn btn-sm btn-outline-success float-end" [routerLink]="['/app/create-scale']">
			<fa-icon [icon]="['fas', 'plus']"></fa-icon>
			Create Scale
		</a>
	</h2>
	<div class="card-body pt-1">
		<div class="row">
			<div class="col-md-12">
				<div class="table-responsive">
					<table datatable [dtOptions]="dtOptions" class="table table-striped table-bordered table-hover"
						style="width: 100%;">
						<thead>
							<tr class="table_head">
								<th style="width: 50% !important;">Scale</th>
								<th style="width: 40% !important;">Acronym</th>
								<th style="width: 10% !important;">Action</th>
							</tr>
						</thead>
						<tbody *ngIf="dataList?.length != 0">
							<tr *ngFor="let v of dataList;let i = index;">
								<td>{{ v.scale_name }}</td>
								<td>{{ v.acronym }}</td>
								<td>
									<a class="btn btn-xs btn-outline-primary" matTooltip="Edit"
										[routerLink]="['/app/edit-scale',v.encryptid]">
										<fa-icon [icon]="['fas', 'edit']"></fa-icon>
									</a>
									<button type="button" class="btn btn-xs btn-outline-danger ms-1" matTooltip="Delete"
										(click)="deleteConfirm(v.encryptid,i)">
										<fa-icon [icon]="['fas', 'times']"></fa-icon>
									</button>
								</td>
							</tr>
						</tbody>
						<tbody *ngIf="dataList?.length == 0">
							<tr>
								<td colspan="3" class="text-center">No data found!</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</div>
<div *ngIf="moduleAccess!='Full'">
	<h3 class="text-center">You don't have access to this section.</h3>
</div>